import { ISymbolMappingFilterStore } from './symbolMappingFilter.interface';

export const symbolMappingFilterInitialState: ISymbolMappingFilterStore = {
  filter: undefined,
};
